import { useEffect, useState } from "react";

const links = [
  { href: "#latest", label: "最新求证" },
  { href: "#reversal", label: "反转追踪" },
  { href: "#guide", label: "分辨指南" },
  { href: "#categories", label: "关注栏目" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200/70"
          : "bg-background-50/60 border-b border-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-[4.5rem] max-w-7xl items-center justify-between px-4 md:px-6">
        {/* 品牌 H1 */}
        <h1 className="flex items-center gap-2.5">
          <a href="#top" className="flex items-center gap-2.5" aria-label="55黑料 首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-700 font-heading text-base font-bold text-background-50">
              55
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
                黑料求证
              </span>
              <span className="mt-1 text-[10px] font-medium tracking-widest text-foreground-500">
                求真 · 辟谣 · 反转追踪
              </span>
            </span>
          </a>
        </h1>

        {/* 桌面导航 */}
        <div className="hidden items-center gap-1 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-full px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-2.5 md:flex">
          <a
            href="#contact"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-600 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700"
          >
            <i className="ri-megaphone-line text-base" aria-hidden="true"></i>
            提交线索
          </a>
        </div>

        {/* 移动端汉堡 */}
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-full border border-background-200 text-foreground-800 md:hidden"
          aria-label={open ? "关闭菜单" : "打开菜单"}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} aria-hidden="true"></i>
        </button>
      </nav>

      {/* 移动端面板 */}
      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-primary-600 px-4 py-2.5 text-sm font-semibold text-background-50"
            >
              <i className="ri-megaphone-line text-base" aria-hidden="true"></i>
              提交线索
            </a>
          </div>
        </div>
      )}
    </header>
  );
}